var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"el-icon-caret-bottom",style:(("color: " + (_vm.directionSort === 'DESC' ? '#1e88e5' : '#BDBDBD')))})}
var staticRenderFns = []

export { render, staticRenderFns }